import { render, staticRenderFns } from "./productUnitAdd.vue?vue&type=template&id=32c17649&scoped=true"
import script from "./productUnitAdd.vue?vue&type=script&lang=js"
export * from "./productUnitAdd.vue?vue&type=script&lang=js"
import style0 from "./productUnitAdd.vue?vue&type=style&index=0&id=32c17649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c17649",
  null
  
)

export default component.exports